/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SearchCollectionGetCustomMetadataEntryValueResponseDto } from './SearchCollectionGetCustomMetadataEntryValueResponseDto';

export type GetCustomMetadataResponseDto = {
    authorizedAssets: Array<'TABLE_AND_VIEW' | 'DASHBOARD' | 'PIPELINE' | 'DECLARATIVE_ASSET' | 'MONITOR'>;
    description?: string;
    entries: SearchCollectionGetCustomMetadataEntryValueResponseDto;
    id: string;
    isAllowMultipleValues: boolean;
    isShowInFilter: boolean;
    name: string;
    origin: GetCustomMetadataResponseDto.origin;
    type: GetCustomMetadataResponseDto.type;
};

export namespace GetCustomMetadataResponseDto {

    export enum origin {
        SIFFLET = 'SIFFLET',
        ATLAN = 'ATLAN',
        ALATION = 'ALATION',
        AMUNDSEN = 'AMUNDSEN',
        APACHE_ATLAS = 'APACHE_ATLAS',
        CASTOR_DOC = 'CASTOR_DOC',
        COLLIBRA = 'COLLIBRA',
        DATAGALAXY = 'DATAGALAXY',
        INFORMATICA = 'INFORMATICA',
        SECODA = 'SECODA',
        SELECT_STAR = 'SELECT_STAR',
        CATALOG_GENERIC = 'CATALOG_GENERIC',
    }

    export enum type {
        LABEL = 'LABEL',
        USER = 'USER',
        STRING = 'STRING',
        TEAM = 'TEAM',
    }


}
